module.exports = __webpack_public_path__ + "img/process2.9adab122.png";